<template>
  <div>
    <div class="table">
      <el-table :data="tableData" style="width: 100%;margin-top: 20px;" height='calc(100vh - 200px)'>
        <el-table-column type="index" label="序号"></el-table-column>
        <el-table-column prop="detail.name" label="渠道名称"></el-table-column>
        <el-table-column label="时间">
          <template slot-scope='scope'>
            {{setTime(scope.row.detail.createAt)}}
          </template>
        </el-table-column>
        <el-table-column prop="detail.code" label="订单号">
        </el-table-column>
        <el-table-column prop="product.name" label="产品名称">
        </el-table-column>

        <el-table-column label="分成金额">
          <template slot-scope='scope'>
            <span class="yellow">{{scope.row.detail.amount/100}} 元</span>
          </template>
        </el-table-column>
        <el-table-column label="支付方式">
          <template slot-scope='scope'>
            {{billingState[scope.row.detail.billingState]}}
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="fenye">
    	<pages class='pagination' :allpage='allpage' :changePage='changePage'></pages>
    </div>
  </div>
</template>

<script>
  import { getInvoiceDetail } from '@/axios/api.js'
  import common from '@/assets/common.js'
  export default{
    data() {
      return {
        tableData: [],
        allpage:10,
        billingState:['创建','线上支付完成','挂帐月结-未付','线下转账-已付款','已退单','投保失败退单'],
      }
    },
    mounted() {
      this.getData()
    },
    methods: {
    	changePage(start,count){
    		this.getData(start,count)
    	},
    	setTime(str){
    		return common.time(str)
    	},
    	getData(start,count) {
    		var data={
          start:start||0,
          count:count||10,
          invoiceId:this.$route.query.id
        }
    		getInvoiceDetail(data)
    		.then(res => {
    			console.log(res)
    			this.tableData=res.data.obj;
    			this.allpage=res.data.obj2
    		})
    		.catch( err => {
    			console.log(err)
    		})
    	}
    },
  }
</script>

<style scoped="scoped">
  .title{padding-top: 10px;}
</style>



// WEBPACK FOOTER //
// src/views/financial/settlement/invoiceDetail.vue